import React, { useState } from "react";
import axios from "axios";
import Navbar from "./navbar";
import Header from "./header";

const UploadJson = () => {
  const [file, setFile] = useState(null);
  const [name, setName] = useState("");

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleFileUpload = async () => {
    if (!file || !name) {
      alert("Please select a file and enter a name.");
      return;
    }

    const formData = new FormData();
    formData.append("jsonFile", file);
    formData.append("name", name);

    try {
      const response = await axios.post(
        "http://localhost/upvc/upload-profile/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-Requested-With": "XMLHttpRequest",
          },
        }
      );

      if (response.data.status === "success") {
        // console.log("File uploaded successfully!");
        alert("File uploaded successfully!");
        setFile(null);
        setName("");
      } else {
        console.error("Upload failed:", response.data.message);
        alert("Upload failed: " + response.data.message);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Upload failed: " + (error.response?.data?.message || error.message));
    }
  };

  return (
    <>
      <Navbar />
      <Header />

      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-md-12 col-xxl-12 col-xl-12">
              <div className="card">
                <div className="card-body">
                  <div className="row align-items-center">
                    <h2 className="text-xl font-bold mb-4 text-center">
                      Upload Profile in JSON File
                    </h2>

                    <div className="col-12 mb-2 mt-3 text-center">
                      <p>Name</p>
                      <input
                        type="text"
                        placeholder="Enter Name"
                        value={name}
                        onChange={handleNameChange}
                        className="mb-2 border p-2"
                      />
                    </div>

                    <div className="col-12 mb-2 mt-3 text-center">
                      <p>Select File</p>
                      <input
                        type="file"
                        accept=".json"
                        onChange={handleFileChange}
                        className="mb-2 border p-2"
                      />
                    </div>

                    <div className="col-12 mb-2 mt-3 text-center">
                      <button
                        onClick={handleFileUpload}
                        className="btn btn-success mt-2 w-25"
                      >
                        Upload
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadJson;
